import * as Yup from 'yup';
import { Holiday } from '@models';

export function useValidationSchema() {
  return Yup.object<Holiday>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    day: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<Holiday>;
}
